/**
 * @param {string} src
 * @returns {Promise<HTMLImageElement>}
 */
function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener('load', () => resolve(img));
    img.addEventListener('error', reject);
    img.src = src;
  });
}

/**
 * @param {string} imageSrc Object URL or URL of the room image
 * @param {{ x: number; y: number; width: number; height: number }} cropPixels natural pixels from react-easy-crop
 * @param {number} outWidth
 * @param {number} outHeight
 * @param {number} [jpegQuality]
 * @returns {Promise<Blob>}
 */
export async function exportCroppedRoomJpeg(imageSrc, cropPixels, outWidth, outHeight, jpegQuality = 0.92) {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = outWidth;
  canvas.height = outHeight;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Could not create canvas context.');
  }
  ctx.drawImage(
    image,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    outWidth,
    outHeight,
  );
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) reject(new Error('Could not encode cropped image.'));
        else resolve(blob);
      },
      'image/jpeg',
      jpegQuality,
    );
  });
}
